import React from 'react'
import { Box } from '@material-ui/core'
import { RuleStepProps } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { FixedAmountRuleState } from './types'
import {
	NumSpinner,
	ParamRow,
	RuleParamsPanel,
} from '../../CampaignModalSkeleton/components'

export function FixedAmountRuleStep({
	rule,
	setRule,
	description,
}: RuleStepProps<FixedAmountRuleState>) {
	const discountError =
		rule.discount !== null &&
		(rule.discount <= 0 || rule.discount >= (rule.threshold || Infinity))
	const thresholdError = rule.threshold !== null && rule.threshold <= 0

	return (
		<Box>
			{description}
			<RuleParamsPanel>
				<ParamRow
					label="Montant du code promotionnel"
					description="Valeur offerte une fois le seuil de panier atteint"
					error={discountError}
				>
					<NumSpinner
						value={rule.discount}
						onChange={(v) => setRule((prev) => ({ ...prev, discount: v }))}
						min={1}
						max={999999}
						suffix="€"
						placeholder="20"
						step="any"
					/>
				</ParamRow>
				<ParamRow
					label="Seuil de déblocage"
					description="Le client doit dépenser au moins ce montant pour obtenir le code"
					error={thresholdError}
					isLast
				>
					<NumSpinner
						value={rule.threshold}
						onChange={(v) => setRule((prev) => ({ ...prev, threshold: v }))}
						min={1}
						max={999999}
						suffix="€"
						placeholder="20"
						step="any"
					/>
				</ParamRow>
			</RuleParamsPanel>
		</Box>
	)
}
